<section class="skill-section">
    <div class="container-fluid">
        <div class="row align-items-center justify-content-center">
            <div class="col-lg-6 col-md-10 mt-5">
                <img src="assets/img/imgSection5.png" alt="img">
            </div>
            <div class="col-lg-6 col-md-10 text-center">
                <h1 class="titleSecc5">Beneficio de su <br/> implementación.</h1>
                <br/>
                <div class="piechart-boxes">
                    <div class="chart-box">
                        <img src="assets/img/icon4.png" alt="icon1">
                        <h4 class="title">Incremento del precio <br/> de venta en corto / <br/> mediano plazo.</h4>
                    </div>
                    <div class="chart-box">
                        <img src="assets/img/icon1.png" alt="icon2">
                        <h4 class="title">Diferenciación de <br/> productos / valor <br/> agregado.</h4>
                    </div>
                    <div class="chart-box">
                        <img src="assets/img/icon3.png" alt="icon3">
                        <h4 class="title">Acceso a nuevos <br/> mercados y exportación.</h4>
                    </div>
                    <div class="chart-box">
                        <img src="assets/img/icon2.png" alt="icon4">
                        <h4 class="title">Mejora de la <br/> gestión de la UP.</h4>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>